var moduleMap = {
	"./makeOffer": () => {
		return Promise.all([__webpack_require__.e(608), __webpack_require__.e(686), __webpack_require__.e(493), __webpack_require__.e(585), __webpack_require__.e(364), __webpack_require__.e(46), __webpack_require__.e(340), __webpack_require__.e(559), __webpack_require__.e(521), __webpack_require__.e(284)]).then(() => (() => ((__webpack_require__(40515)))));
	},
	"./reviewOffer": () => {
		return Promise.all([__webpack_require__.e(608), __webpack_require__.e(989), __webpack_require__.e(493), __webpack_require__.e(130), __webpack_require__.e(364), __webpack_require__.e(46), __webpack_require__.e(340), __webpack_require__.e(559), __webpack_require__.e(200), __webpack_require__.e(65)]).then(() => (() => ((__webpack_require__(27065)))));
	},
	"./offerManagement": () => {
		return Promise.all([__webpack_require__.e(608), __webpack_require__.e(686), __webpack_require__.e(989), __webpack_require__.e(493), __webpack_require__.e(442), __webpack_require__.e(364), __webpack_require__.e(46), __webpack_require__.e(559), __webpack_require__.e(885)]).then(() => (() => ((__webpack_require__(81885)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var oldScope = __webpack_require__.S["default"];
	var name = "default"
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});